import { FF_BRAZE_CONTENT_CARDS } from '@/constants/featureFlags';
import { usePortalPartnerBrand } from '@/hooks/portal-partner-brand';
import useFeatureFlags from '@/hooks/useFeatureFlags';
import { Box, CircularProgress } from '@montugroup/design-system';
import { alternaleaf, BrandThemeProvider } from '@montugroup/themes';
import { styled, useMediaQuery } from '@mui/material';
import { Suspense } from 'react';
import { PageBanner } from '../banners/PageBanner';
import { BrazePageMessaging } from '../braze/BrazePageMessaging';
import AlertSnackbarProvider from '../error/AlertSnackbarProvider';
import { ContentWrapper, MainContentBox, PageContentWrapper } from './PageLayout.styles';
import MobileAppBar from './navbar/MobileAppBar';
import Sidebar from './sidebar/Sidebar';

const LegacyAlertContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: '0 5%',
  [theme.breakpoints.up('md')]: {
    padding: '0 10%',
  },
}));

export const PageLayout = ({ children }: { children: React.ReactNode }) => {
  const isLargeView = useMediaQuery(alternaleaf.breakpoints.up('md'));
  const { key: partnerkey } = usePortalPartnerBrand();
  const { flags } = useFeatureFlags();

  return (
    <BrandThemeProvider theme={partnerkey}>
      <MainContentBox>
        <AlertSnackbarProvider>
          {isLargeView ? <Sidebar /> : <MobileAppBar />}
          <PageContentWrapper>
            {flags[FF_BRAZE_CONTENT_CARDS] && <BrazePageMessaging />}
            <ContentWrapper>
              <LegacyAlertContainer>
                <PageBanner />
              </LegacyAlertContainer>
              <Suspense fallback={<CircularProgress />}>{children}</Suspense>
            </ContentWrapper>
          </PageContentWrapper>
        </AlertSnackbarProvider>
      </MainContentBox>
    </BrandThemeProvider>
  );
};
